<template>
	<div class="text-left" @click="$emit('click', $event)" v-if="isConditionMet">
		<v-form @submit.prevent v-model="isValid" lazy-validation ref="form">
			<div class="form-question"><span class="question-content" v-html="questionHtml(item.question)"></span> <span v-if="item.required" class="font-red brand-medium">*</span>  <v-icon v-if="showConditionalHelper" small color="gray_50">account_tree</v-icon></div>
			<div
				:class="`${item.formatVertically ? 'column-format' : 'row-format'} gap-2 mb-3 mt-n1 brand-choice-group`"
				style="flex-wrap: wrap"
				:key="refreshKey"
			>
				<v-checkbox
					:disabled="disabled"
					class="form-checkbox form-input mb-n3"
					v-for="(option, index) in item.options"
					:key="index"
					:value="option"
					v-model="selection"
					:label="option"
					dense
					hide-details
					:rules="item.required ? checkboxInputRequired : []"
					@change="handleChange()"
				></v-checkbox>
				<div v-if="item.hasOther" class="row-format align-center gap-2 other-choice">
					<v-checkbox
						:disabled="disabled"
						class="form-checkbox form-input mb-n3"
						:value="otherOption"
						v-model="selection"
						:label="otherLabel"
						dense
						hide-details
						:rules="item.required ? checkboxInputRequired : []"
						@change="handleChange()"
					></v-checkbox>
					<v-text-field
						v-model="otherText"
						:disabled="disabled"
						:outlined="outlined"
						:solo="solo"
						:filled="filled"
						:aria-label="otherLabel"
						:placeholder="otherHint"
						class="form-input other-text"
						hide-details
						dense
						@input="handleOtherInput()"
					></v-text-field>
				</div>
			</div>
		</v-form>
	</div>
</template>

<script>
	import RendererMixin from '@/modules/forms/v2/schema/RendererMixin';
	import { OTHER_OPTION, otherAnswerValues, otherChoiceLabel, otherPlaceholder, splitOtherAnswer } from '@/modules/forms/v2/schema/otherOption';

	export default {
		name: 'Checkbox',

		props: ['disabled', 'item', 'styles', 'index','results', 'builder','container'],

		mixins: [RendererMixin],

		data: function () {
			return {
				refreshKey: 1,
				selection: [],
				otherText: '',
				otherOption: OTHER_OPTION,
			};
		},

		mounted() {
			let currentResult = this.getCurrentResult(this.item.id,this.results);
			if(currentResult){
				({ selection: this.selection, otherText: this.otherText } = splitOtherAnswer(this.item, currentResult));
			}
		},

		beforeDestroy() {},

		methods: {
			handleChange: function () {
				if(this.answerValues.length) {
					this.$emit('input', {item: this.item, value: this.answerValues, index: this.index,  container: this.container});
				}else{
					this.$emit('input', {item: this.item, value: null, index: this.index, container: this.container});
				}
			},

			// Typing an Other answer selects the Other choice.
			handleOtherInput: function () {
				if (this.otherText.trim() && !this.selection.includes(OTHER_OPTION)) {
					this.selection = [...this.selection, OTHER_OPTION];
				}
				this.handleChange();
			},
		},

		computed: {
			otherLabel() {
				return otherChoiceLabel(this.item, this.$t('discovery.other'));
			},

			otherHint() {
				return otherPlaceholder(this.item);
			},

			answerValues() {
				return otherAnswerValues(this.selection, this.otherText);
			},

			checkboxInputRequired() {
				return [this.answerValues.length > 0 || 'Required'];
			},
		},

		watch: {
			'item.options': {
				deep: true,
				handler: function () {
					this.refreshKey++;
				},
			},
		},
	};
</script>

<style lang="scss">
	.form-checkbox {
		.v-label {
			color: var(--font-color)!important;
		}
		.v-input--selection-controls__input {
			margin-right: 0px !important;
		}
	}

	.other-choice .other-text {
		flex: 0 1 240px;
		min-width: 140px;
	}
</style>
